// extracted by css-extract-rspack-plugin
export default {"page":"GroupBookingV2-module__page","formPanel":"GroupBookingV2-module__formPanel"};